<!--模板界面-->
<template>
	<div class="bg">
		<p class="titleText">负荷监测</p>
		<img src="../../../../public/static/杭州东杰定制/看板/站点概况/titleBottom.png" style="margin: 10px 0;width: 100%;">
		<div class="flexBetween" style="width: 80%;margin: 0 10%;">
			<div class="flexCenterColumn leftIco">
				<img src="../../../../public/static/杭州东杰定制/看板/能耗信息/cycleIco.png">
				<div class="line"></div>
				<img src="../../../../public/static/杭州东杰定制/看板/能耗信息/cycleIco.png">
				<div class="line"></div>
				<img src="../../../../public/static/杭州东杰定制/看板/能耗信息/cycleIco.png">
				<div class="line"></div>
				<img src="../../../../public/static/杭州东杰定制/看板/能耗信息/cycleIco.png">
			</div>
			<div style="width: calc(100% - 30px);">
				<div class="powerInfoLine flexBetween">
					<p>负荷容量(kW)</p>
					<p>{{loadCapacity}}</p>
				</div>
				<div class="bar" style="background: rgba(0,0,0,0);"></div>
				<div class="powerInfoLine flexBetween">
					<p>实时负荷(kW)</p>
					<p>{{realLoad}}</p>
				</div>
				<horizontalProgressBar class="bar" bgColor='#284c87' barColor="#1df0f2" :rate='realLoadRate'></horizontalProgressBar>
				<div class="powerInfoLine flexBetween">
					<p>日最大负荷(kW)</p>
					<p>{{dayMaxLoad}}</p>
				</div>
				<horizontalProgressBar class="bar" bgColor='#284c87' barColor="#1df0f2" :rate='dayMaxRate'></horizontalProgressBar>
				<div class="powerInfoLine flexBetween">
					<p>月最大负荷(kW)</p>
					<p>{{monthMaxLoad}}</p>
				</div>
				<horizontalProgressBar class="bar" bgColor='#284c87' barColor="#1df0f2" :rate='monthMaxRate'></horizontalProgressBar>
			</div>
		</div>
	</div>
</template>

<script>
	import horizontalProgressBar from '@/components/module/progressbar/horizontalProgressBar.vue'
	export default {
		components: {
			horizontalProgressBar
		},
		props: {},
		data() {
			return {
				deviceNoToArchivesInfo: {},
				dayMaxLoad: 0,
				monthMaxLoad: 0,
				nowLoadDeviceFromname: undefined
			}
		},
		created() {},
		mounted() {
			debugPage = this
			this.getLoadDeviceList(this.nowUnit.id)
			addNewTask("refreshUnitDayInfo", 0, 5 * 60 * 1000, -1, () => {
				this.getLoadDeviceList(this.nowUnit.id)
			})
		},
		destroyed() {
			this.realTimeValueStore.commit("removeKeys", this.nowLoadDeviceFromname)
			removeTask("refreshUnitDayInfo")
		},
		computed: {
			realTimeValueStore() {
				return this.$store.realTimeValueStore
			},
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			loadCapacity() {
				//总负荷容量
				return this.$store.unitStore.getters.getLoadCount(this.nowUnit.id)
			},
			realLoad() {
				if (isempty(this.nowLoadDeviceFromname)) {
					return '--'
				}
				var values = this.realTimeValueStore.getters.getValue(this.nowLoadDeviceFromname)
				var count = 0
				for (var i = 0, len = values.length; i < len; i++) {
					if (values[i] != undefined) {
						count += parseFloat(values[i])
					}
				}
				//实时负荷
				return cutDigital(count)
			},
			realLoadRate() {
				if (this.loadCapacity != 0 && this.realLoad != 0) {
					return parseFloat(this.realLoad / this.loadCapacity * 100)
				}
				return 0
			},
			dayMaxRate() {
				var rate = 0
				try {
					rate = parseFloat(this.dayMaxLoad / this.loadCapacity * 100)
					if (isNaN(rate)) {
						return 0
					}
				} catch (e) {}
				return rate
			},
			monthMaxRate() {
				var rate = 0
				try {
					rate = parseFloat(this.monthMaxLoad / this.loadCapacity * 100)
					if (isNaN(rate)) {
						return 0
					}
				} catch (e) {}
				return rate
			}
		},
		watch: {
			nowUnit(nv, ov) {
				this.getLoadDeviceList(nv.id)
			},
			nowLoadDeviceFromname(nv, ov) {
				if (!isempty(ov)) {
					//移除旧变量
					this.realTimeValueStore.commit("removeKeys", ov)
				}
				if (!isempty(nv)) {
					this.realTimeValueStore.commit("addKeys", nv)
				}
			},
		},
		methods: {
			getLoadDeviceList(unitId) {
				if (isempty(unitId)) {
					return
				}
				//查询日最大负荷
				this.$api.powerApi.getDayMaxLoad(unitId, Date.now(), respon => {
					this.dayMaxLoad = isempty(respon) ? '--' : respon
				})
				//查询月最大负荷
				this.$api.powerApi.getMonthMaxLoad(unitId, Date.now(), respon => {
					this.monthMaxLoad = isempty(respon) ? '--' : respon
				})
				//获取实时负荷
				this.$api.powerApi.getLoadFromnameByUnitId(unitId, respon => {
					this.nowLoadDeviceFromname = isempty(respon) ? '--' : respon
				})
			}
		}
	}
</script>

<style scoped>
	.powerInfoLine {
		width: 100%;
		height: 40px;
	}

	.powerInfoLine>p {
		padding-top: 8px;
		line-height: 32px;
	}

	.powerInfoLine>p:first-of-type {
		width: 126px;
		font-size: 12px;
	}

	.powerInfoLine>p:last-of-type {
		color: #f4a214;
		font-size: 18px;
		font-weight: bold;
		width: 80px;
		text-align: right;
	}

	.powerInfoLine>img {
		width: 20px;
		margin-right: 15px;
	}

	.bar {
		width: 100%;
		height: 8px;
		margin-right: 27px;
	}
	.leftIco>img{
		height: 20px;
	}
	.line {
		height: 28px;
		background: white;
		width: 1px;
	}
	
</style>
